import initReactComponent from '../common/utilities/initReactComponent';
import Page from './Page';

initReactComponent(Page, '.js-support-schedule-static');
